'use strict';

var React = require('react');
var CompositeIconBase = require('../common/CompositeIconBase');
var IconLabel2 = React.createClass({
  render: function(){

    return (<CompositeIconBase
      {...this.props}
      borderVisible={false}
      alarmVisible={this.props.showAlarm || false}
      iconVisible={true}
      labelVisible={this.props.showText}>
      {
        this.props.children
      }
    </CompositeIconBase>);
  }
});

module.exports = IconLabel2;


// WEBPACK FOOTER //
// ./src/views/Components/IconLabel2.jsx